import type { ReactNode } from "react";

export interface EmptyStateProps {
	readonly title: ReactNode;
	readonly message?: ReactNode;
	readonly symbol?: ReactNode;
	/** Optional call-to-action button label. */
	readonly actionLabel?: ReactNode;
	/** Optional call-to-action icon. */
	readonly actionSymbol?: ReactNode;
	readonly onAction?: () => void;
	readonly className?: string;
}

/**
 * EmptyState — centered placeholder for empty data states. Mirrors
 * `DSEmptyState` on iOS with an optional CTA action.
 */
export function EmptyState({
	title,
	message,
	symbol = "○",
	actionLabel,
	actionSymbol,
	onAction,
	className = "",
}: Readonly<EmptyStateProps>) {
	return (
		<section className={`ds-empty-state ${className}`.trim()}>
			<span aria-hidden="true">{symbol}</span>
			<strong>{title}</strong>
			{message === undefined ? null : <p>{message}</p>}
			{actionLabel === undefined ? null : (
				<button
					type="button"
					className="ds-button ds-button--md ds-button--primary"
					onClick={onAction}
				>
					{actionSymbol === undefined ? null : (
						<span className="ds-button__symbol" aria-hidden="true">
							{actionSymbol}
						</span>
					)}
					<span>{actionLabel}</span>
				</button>
			)}
		</section>
	);
}
